module.exports = __webpack_public_path__ + "img/16.14d6a39d.webp";